import { CheckIcon, AlertIcon, SearchIcon } from "./Icons.js";

export function SuccessState({ title, children }: { title: string; children?: any }) {
  return (
    <div className="state-block state-block--success" role="status">
      <div className="state-block__icon">
        <CheckIcon size={28} />
      </div>
      <h3>{title}</h3>
      {children}
    </div>
  );
}

export function ErrorState({ title, children }: { title: string; children?: any }) {
  return (
    <div className="state-block state-block--error" role="alert">
      <div className="state-block__icon">
        <AlertIcon size={28} />
      </div>
      <h3>{title}</h3>
      {children}
    </div>
  );
}

export function EmptyState({ title, children }: { title: string; children?: any }) {
  return (
    <div className="state-block state-block--empty">
      <div className="state-block__icon">
        <SearchIcon size={28} />
      </div>
      <h3>{title}</h3>
      {children}
    </div>
  );
}

export function LoadingState({ label = "Bezig met laden…" }: { label?: string }) {
  return (
    <div className="flex items-center gap-2" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true"></span>
      <span>{label}</span>
    </div>
  );
}

export function ValidationMessage({ id, children }: { id?: string; children: any }) {
  if (!children) return null;
  return (
    <p className="validation-message" id={id} role="alert">
      <AlertIcon size={14} /> {children}
    </p>
  );
}
